import { registerAction } from '../../Action'

const LOAD_STORY_CSV_ROW_COUNT = 'LOAD_STORY_CSV_ROW_COUNT'

const reducer = (state = {}, action) => ({
  ...state,
  storyCSVRowCount: parseInt(action.payload.meta.total, 10),
})

const loadStoryCSVRowCount = registerAction(LOAD_STORY_CSV_ROW_COUNT, {
  reducer,
})

export default loadStoryCSVRowCount
